const dataHooks = [
  {
    title: "useFetch Custom Hook",
    shortDescription:
      "The 'Copy-Paste' killer. Write your API logic once, and reuse it in every component.",
    description:
      "In a real app, you fetch data in many places (User Profile, News Feed, Settings). Beginners often write the same `fetch().then().catch()` code over and over again. This project teaches you how to extract that logic into a 'Custom Hook'. It is a reusable function that handles the boring stuff—turning on the loading spinner, catching errors, and parsing the JSON—so your main components stay clean and simple.",
  },
];

export default dataHooks;